import React from 'react';
import { SigningOfContractAndInvoicePayment } from './form-steps/01-signing-of-contract-and-invoice-payment';
import { ContactDetailsAndProjectSpecification } from './form-steps/02-contact-details-and-project-specification';
import { DataAndAccessCheck } from './form-steps/03-data-and-access-check';
import { GraphicDesign } from './form-steps/04-graphic-design';
import { SigningAcceptanceProtocolDesign } from './form-steps/05-signing-acceptance-protocol-design';
import { SystemInstallationOnDomainServer } from './form-steps/06-system-installation-on-domain-server';
import { VisualImplementationAndSystemIntegration } from './form-steps/07-visual-implementation-and-system-integration';
import { AcceptanceProtocolDesignImplementationAndIntegration } from './form-steps/08-acceptance-protocol-design-implementation-and-integration';
import { ProjectContentManagement } from './form-steps/09-project-content-management';
import { MigrationToProduction } from './form-steps/10-migration-to-production';
import { FinalProjectConfirmation } from './form-steps/11-final-project-confirmation';
import ClockLoader40 from './icons/clock-loader-40';
import { Sheet, SheetContent, SheetTrigger } from '@eliadmin/core/src/components/ui/sheet';
import { StartSidebar } from './start-sidebar';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

const StartFormSteps: Record<number, () => JSX.Element> = {
  1: SigningOfContractAndInvoicePayment,
  2: ContactDetailsAndProjectSpecification,
  3: DataAndAccessCheck,
  4: GraphicDesign,
  5: SigningAcceptanceProtocolDesign,
  6: SystemInstallationOnDomainServer,
  7: VisualImplementationAndSystemIntegration,
  8: AcceptanceProtocolDesignImplementationAndIntegration,
  9: ProjectContentManagement,
  10: MigrationToProduction,
  11: FinalProjectConfirmation,
};

type StartFormProps = {
  currentStep: number;
  setStep: (step: number) => void;
};

export const StartForm = ({ currentStep, setStep }: StartFormProps) => {
  const { t } = useTranslations();

  const StepComponent = StartFormSteps[currentStep];

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between">
        <h1 className="text-[14px] leading-[20px] sm:text-lg">
          {t('text860').toUpperCase()} {currentStep}/11
        </h1>
        <div className="font-semibold text-primary sm:hidden">
          <Sheet>
            <SheetTrigger className="flex items-center gap-1">
              <ClockLoader40 className="h-4 w-4" />
              <p className="text-[14px] leading-[20px]">Progress</p>
            </SheetTrigger>
            <SheetContent
              side={'bottom'}
              className="max-h-[100vh] w-[100vw] overflow-y-auto rounded-t-lg bg-[#FAFAFA]"
            >
              <h1 className="text-2xl font-bold">Progress</h1>
              <StartSidebar currentStep={currentStep} setStep={setStep} inSheet />
            </SheetContent>
          </Sheet>
        </div>
      </div>
      {StepComponent ? <StepComponent /> : <p>Error</p>}
    </div>
  );
};
